module.exports = __webpack_public_path__ + "media/components/t-shirt-comp/static/t-shirts-background-b95ce27685da6139bdf423d9f80da48d.jpg";